import React from 'react';
import './UtilityInfo.scss'; // Import the CSS file for styling

const formatUtilityType = (type) => {
  if (!type || typeof type !== 'string') return '';

  // Convert camelCase or any other format to words with spaces and capitalize each word
  const formattedType = type
    .replace(/([a-z])([A-Z])/g, '$1 $2') // Add space between camel case words
    .replace(/[_-]/g, ' ') // Replace underscores and hyphens with spaces
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word

  return formattedType;
};

const UtilityInfo = ({ utilityData, accessibility }) => {
  
  const hasUtilities = utilityData?.electricity?.type ||
    utilityData?.water?.type ||
    utilityData?.heating?.length > 0 ||
    utilityData?.internet?.type ||
    utilityData?.water?.sewerage ||
    utilityData?.mainHeating?.length > 0 ||
    accessibility?.length > 0;

  return (
    <div className="utilities-info-wrap">
      {hasUtilities && 
        <h6 className="utilities-info-title">Utilities</h6>
      }
      <ul className="utility-listing">
        {utilityData?.electricity?.type && (
          <li>
            <p className="utility-title">Electricity</p>
            <p className="utility-value">{formatUtilityType(utilityData.electricity.type)}</p>
          </li>
        )}
        {utilityData?.water?.type && (
          <li>
            <p className="utility-title">Water</p>
            <p className="utility-value">{formatUtilityType(utilityData.water.type)}</p>
          </li>
        )}
        {utilityData?.heating?.length > 0 && (
          <li>
            <p className="utility-title">Heating</p>
            <p className="utility-value">
              {utilityData.heating.map(formatUtilityType).join(', ')}
            </p>
          </li>
        )}
        {utilityData?.internet?.type && (
          <li className="broadband-list">
            <p className="utility-title">Broadband</p>
            <p className="utility-value">
              {Array.isArray(utilityData.internet.type) 
                ? utilityData.internet.type.map(formatUtilityType).join(', ') 
                : formatUtilityType(utilityData.internet.type)
              }
            </p>
          </li>
        )}
        {utilityData?.water?.sewerage && (
          <li>
            <p className="utility-title">Sewerage</p>
            <p className="utility-value">{formatUtilityType(utilityData.water.sewerage)}</p>
          </li>
        )}
        {utilityData?.mainHeating?.length > 0 && (
          <li>
            <p className="utility-title">Main Heating</p>
            <p className="utility-value">{utilityData.mainHeating.map(formatUtilityType).join(', ')}</p>
          </li>
        )}
        {accessibility?.length > 0 && (
          <li className="accessibility-list">
            <p className="utility-title">Accessibility</p>
            <p className="utility-value">{accessibility.map(formatUtilityType).join(', ')}</p>
          </li>
        )}
      </ul>
    </div>
  );
};

export default UtilityInfo;